import { createFileRoute } from '@tanstack/react-router';
import { resolveOrganizationRef } from '@/app/organization-ref';
import { SettingsLayout } from '@/features/settings/settings-layout';

export const Route = createFileRoute('/_app/o/$organizationId/settings')({
    beforeLoad: ({ context, params, location }) =>
        resolveOrganizationRef(context.queryClient, params.organizationId, location),
    component: function SettingsRoute() {
        const { organizationId } = Route.useParams();
        return <SettingsLayout organizationId={organizationId} />;
    },
});
